export const environment = {
    production: true,
    baseUrl: 'https://apps.theguru.co/',
    apiUrl: 'https://apps.theguru.co/api/saas/'
};



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/environments/environment.ts